import { jsx as _jsx } from "react/jsx-runtime";
import Link from 'react-router/lib/Link';
export var EditAction = function (_a) {
    var brand = _a.brand;
    return (_jsx("span", { children: _jsx(Link, { className: "u-co-primary u-type--bold", to: "/admin/brands/".concat(brand.id), children: "Edit" }) }));
};
